import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { IAPIData } from '@shared/interfaces/api.interface';
import { IIntegrationsGreenhouse } from '@shared/interfaces/integrations/integrations.greenhouse.interface';
import { IntegrationsGreenhouse } from '@shared/models/integrations/integrations.greenhouse.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsGreenhouseService {
  private readonly ENDPOINT: string = String(
    `${environment.SERVER_ENDPOINT}/api/services/greenhouse`
  );

  constructor(private readonly _http: HttpClient) {}

  public authorize(
    params: IIntegrationsGreenhouse
  ): Observable<IIntegrationsGreenhouse> {
    const body = new IntegrationsGreenhouse(params).apiData;
    return this._http
      .post<any>(`${this.ENDPOINT}/auth`, body)
      .pipe(map((res: IAPIData) => IntegrationsGreenhouse.fromAPI(res)));
  }

  public delete(): Observable<IIntegrationsGreenhouse> {
    return this._http
      .delete(this.ENDPOINT)
      .pipe(map((res: IAPIData) => IntegrationsGreenhouse.fromAPI(res)));
  }

  public get(type: string, id: string): Observable<any> {
    return this._http.get(`${this.ENDPOINT}/entity`, {
      params: {
        entity_type: type,
        entity_id: id
      }
    });
  }

  public getWebhook(): Observable<any> {
    return this._http.get(`${this.ENDPOINT}/get_webhook`, {});
  }
}
